import React from 'react';
import TimerCart from "../discount_bundle_page/timer-cart/TimerCard";

const BrandSpecialOffer = () => {
    return (
        <div className="brand-special-offer-wrapper position-relative xpy-lg-14">
            <div className="offer-title position-absolute" style={{backgroundColor: "#FFFF00"}}><span className="text">پیشنهاد ویژه</span>
            </div>
            <div className="row">
                <div className="col-lg-7 order-2 order-lg-1">
                    <div
                        className="product-info d-flex justify-content-center align-items-center flex-column text-center">
                        <div className="name-product-box">
                            <h2 className="big-title">اپل واچ اس ای آلومینیوم گلد با بند اسپورت سیلیکون صورتی نسخه 44
                                میلی‌متری</h2>
                            <h2 className="small-title">Apple Watch SE Gold Aluminum Case With Pink Sport Band 44mm</h2>
                        </div>
                        <div className="buttons d-flex align-items-center xmt-8 xmb-10">
                            <div className="discount-button">
                                <span className="text persian-number">۲،۷۶۰،۰۰۰ ت</span>
                            </div>
                            <div className="total-button">
                                <span className="text persian-number">۲،۷۶۰،۰۰۰ ت</span>
                            </div>
                        </div>
                        <div className="timer">
                            <div className="timer-title">زمان باقی مانده تا پایان سفارش</div>
                            <TimerCart dataTime="april 28, 2022 18:37:25" theme="yellow-timer small"/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-5 order-1 order-lg-2">
                    <div className="product-image d-flex align-items-center justify-content-center justify-content-lg-start xmb-8 xmb-lg-0">
                        <img src="./assets/sample-image/mouse.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandSpecialOffer;
